import { render, staticRenderFns } from "./subscribe-item.vue?vue&type=template&id=63552b1c&scoped=true"
import script from "./subscribe-item.vue?vue&type=script&lang=js"
export * from "./subscribe-item.vue?vue&type=script&lang=js"
import style0 from "./subscribe-item.vue?vue&type=style&index=0&id=63552b1c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63552b1c",
  null
  
)

export default component.exports